var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all:flex"},[_c('Sidebar'),_c('div',{staticClass:"w-full all:flex all:flex-col"},[_c('TopbarWarning'),_c('Topbar'),_c('FreshdeskLauncher'),_c(_vm.layout,{tag:"component"},[_vm._t("default"),_c('OnboardingWidget')],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }